export const convertSVGToPNG = async (imgElement) => {
  if (!imgElement || !(imgElement instanceof HTMLImageElement)) {
    throw new Error("Valid image element is required")
  }

  // Create a canvas element
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")

  // Set canvas dimensions to match image
  canvas.width = imgElement.naturalWidth || imgElement.width
  canvas.height = imgElement.naturalHeight || imgElement.height

  // Draw image to canvas
  ctx.drawImage(imgElement, 0, 0)

  // Convert to PNG with maximum quality
  return canvas.toDataURL("image/png", 1.0)
}
